import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import BudgetBasicInfoComponent from './budget-basic-info.component';

export const BudgetComponent = ({
  handleInnerFormChange, selectedBudgets, back, handleFormSubmit, financialYearsList, methodTypesList,
  budgeTypesList, departmentsList, projectsList
}: any) => {

  const tabItems = [
    {
      id: 1,
      title: 'Basic Information',
      component: <BudgetBasicInfoComponent
        handleInnerFormChange={handleInnerFormChange}
        selectedBudgets={selectedBudgets}
        methodTypesList={methodTypesList}
        budgeTypesList={budgeTypesList}
        financialYearsList={financialYearsList}
        departmentsList={departmentsList}
        projectsList={projectsList}
      />,
      isVisible: true,
    },
  ]

  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">

      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}
          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  )
}

export default BudgetComponent;
